// Ответ «откуда вы о нас узнали» (partials/acquisition-fields.blade.php).
//
// Селект кастомный: кнопка-переключатель bootstrap dropdown + скрытый input со значением.
// Открытие, клавиатура и позиция списка — на bootstrap/Popper (список встаёт под полем, а
// без места снизу — над ним, но не поверх поля, как нативный <select> в части браузеров).
//
// Скрытый input нативной валидации не проходит, поэтому «не выбрано» проверяет validate():
// ошибку показывает сама кнопка (.is-invalid) — у неё .form-control, и тултип ошибки
// подхватывает её так же, как соседние поля.
//
// Поле кода видно на «Рекомендации», поле текста — на «Другом»; скрытое поле не
// отправляется и не валидируется — иначе пустой обязательный текст «Другого»
// блокировал бы форму при любом другом выборе.
export function initAcquisitionFields(form) {
  const input = form.querySelector('[name="acquisition_source"]');
  if (!input) return { getValues: () => ({}), validate: () => true };

  const toggle = form.querySelector('.acquisition-select__toggle');
  const text = toggle.querySelector('.acquisition-select__text');
  const options = Array.from(form.querySelectorAll('.acquisition-select__menu [data-value]'));
  const blocks = Array.from(form.querySelectorAll('[data-acquisition-show]'));
  const comment = form.querySelector('[name="acquisition_comment"]');

  const isShown = (block) => block.dataset.acquisitionShow === input.value;

  const sync = () => {
    blocks.forEach((block) => block.classList.toggle('d-none', !isShown(block)));

    if (comment) {
      comment.required = !comment.closest('[data-acquisition-show]').classList.contains('d-none');
    }
  };

  const choose = (option) => {
    input.value = option.dataset.value;

    text.textContent = option.textContent.trim();
    text.classList.remove('is-placeholder');

    options.forEach((item) => {
      const active = item === option;
      item.classList.toggle('active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    toggle.classList.remove('is-invalid');
    sync();
  };

  options.forEach((option) => {
    option.addEventListener('click', () => choose(option));
  });

  sync();

  return {
    validate() {
      const valid = input.value !== '';
      toggle.classList.toggle('is-invalid', !valid);

      return valid;
    },

    getValues() {
      const values = { acquisition_source: input.value };

      blocks.filter(isShown).forEach((block) => {
        block.querySelectorAll('input').forEach((field) => {
          values[field.name] = field.value.trim();
        });
      });

      return values;
    },
  };
}
